import React, { useState } from 'react';
import {
  Table,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { Link, useHistory } from 'react-router-dom';
import EditOutlineIcon from 'mdi-react/EditOutlineIcon';
import DeleteOutlineIcon from 'mdi-react/DeleteOutlineIcon';
import ArrowDownIcon from 'mdi-react/ArrowDownIcon';
import ArrowUpIcon from 'mdi-react/ArrowUpIcon';
import { partial } from '../../../util/translation/translation';
import { capitalizeFirstLetter, isInfiniteDate } from '../../../util/functions';
import { formatWeekDateTime } from '../../../util/date-and-time';
import Pagination from '../../../shared/components/pagination/Pagination';
import DownloadIcon from 'mdi-react/DownloadIcon';
import ChevronDownIcon from 'mdi-react/ChevronDownIcon';
import Loading from '../../../shared/components/custom/Loading';
import FormCard from '../../../shared/components/custom/FormCard';
import SquareIconButton from '../../../shared/components/custom/SquareIconButton';
import { toast } from 'react-toastify';
import fileDownload from 'js-file-download';
import { Parser } from 'json2csv';
import exportToExcelFile from '../../../util/xlsx';

const s = partial('shared');
const p = partial('UserTiers');
const ut = partial('UsersTab');
const UserTiersList = ({
  title,
  handleModal,
  tierUsers,
  totalItems,
  setReverse,
  reverse,
  onChangePage,
  allTierUsers,
}) => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const renderTierList = () => {
    return tierUsers.map((user) => {
      const parsedDueDate = isInfiniteDate(user.tier.dueDate)
        ? p('neverEnding')
        : formatWeekDateTime(user.tier.dueDate);
      return (
        <tr key={`User-${user.userCloudId}`}>
          <td className="table-stack__primary">{user.firstname}</td>
          <td data-label={s('lastname')}>{user.lastname}</td>
          <td data-label={s('username')}>
            <Link to={`/users/edit/${user.userCloudId}?tab=3`}>
              {user.phoneNumber}
            </Link>
          </td>
          <td data-label={capitalizeFirstLetter(p('tier'))}>
            {user.tier.name}
          </td>
          <td data-label={capitalizeFirstLetter(s('endDate'))}>
            {parsedDueDate}
          </td>
          <td className="table-stack__actions">
            <div className="icon-actions">
              <SquareIconButton
                icon={<EditOutlineIcon />}
                onClick={() =>
                  history.push(`/users/edit/${user.userCloudId}?tab=3`)
                }
                title={s('edit')}
                id={`edit-tier-user-${user.userCloudId}`}
              />
              <SquareIconButton
                icon={<DeleteOutlineIcon />}
                onClick={() => handleModal(true, user.tier.affiliationId)}
                title={s('delete')}
                tone="danger"
                id={`delete-tier-user-${user.userCloudId}`}
              />
            </div>
          </td>
        </tr>
      );
    });
  };
  const renderSort = () => {
    return reverse ? <ArrowUpIcon size={16} /> : <ArrowDownIcon size={16} />;
  };

  const handleExportXLSX = async () => {
    setLoading(true);
    try {
      const fetchedUsers = allTierUsers;
      const tierName = allTierUsers[0].tier.name;
      const data = fetchedUsers.map((user) => {
        const result = {};
        result[`${s('firstname')}`] = user?.firstname;
        result[`${s('lastname')}`] = user?.lastname;
        result[`${s('username')}`] = user?.phoneNumber;
        result[`${s('endDate')}`] = isInfiniteDate(user.tier.dueDate)
          ? p('neverEnding')
          : formatWeekDateTime(user.tier.dueDate);
        return result;
      });
      exportToExcelFile(data, `${p('tier')}-${tierName}`);
    } catch {
      toast.error(s('somethingWentWrong'));
    } finally {
      setLoading(false);
    }
  };

  const handleExport = async () => {
    setLoading(true);
    try {
      const fetchedUsers = allTierUsers;
      const tierName = allTierUsers[0].tier.name;
      const mappedUsers = fetchedUsers.map((user) => {
        return {
          ...user,
          tier: user.tier.name,
          endDate: isInfiniteDate(user.tier.dueDate)
            ? p('neverEnding')
            : formatWeekDateTime(user.tier.dueDate),
        };
      });
      const fields = [
        { label: s('firstname'), value: 'firstname' },
        { label: s('lastname'), value: 'lastname' },
        { label: s('username'), value: 'phoneNumber' },
        { label: p('tier'), value: 'tier' },
        { label: s('endDate'), value: 'endDate' },
      ];
      console.log('mappedUsers--', mappedUsers);
      const json2csvParser = new Parser({ fields });
      const csv = json2csvParser.parse(mappedUsers);
      fileDownload(`\uFEFF${csv}`, `${p('tier')}-${tierName}.csv`);
    } catch {
      toast.error(s('somethingWentWrong'));
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Loading loading={loading} />
      <FormCard
        title={title || s('users')}
        actions={
          <UncontrolledDropdown>
            <DropdownToggle
              className="icon icon--right mb-0 mr-0"
              outline
              size="sm"
            >
              <DownloadIcon /> {s('export')} <ChevronDownIcon />
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem key="exp2" onClick={handleExportXLSX}>
                {ut('exportUsers')} (XLSX)
              </DropdownItem>
              <DropdownItem key="exp1" onClick={handleExport}>
                {ut('exportUsers')} (CSV)
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        }
        bodyClassName="form-card__body--flush"
      >
        <Table striped responsive className="table--roomy table--stack">
          <thead>
            <tr>
              <th>{s('firstname')}</th>
              <th>{s('lastname')}</th>
              <th>{s('username')}</th>
              <th>{capitalizeFirstLetter(p('tier'))}</th>
              <th className="sortable" onClick={() => setReverse(!reverse)}>
                {capitalizeFirstLetter(s('endDate'))} {renderSort()}
              </th>
              <th> </th>
            </tr>
          </thead>
          <tbody>{renderTierList()}</tbody>
        </Table>
      </FormCard>
      <Pagination items={totalItems} onChangePage={onChangePage} />
    </>
  );
};

export default UserTiersList;
